import { FC } from "react";
import classNames from "classnames";
import { BaseColumnProps } from "../BaseColumnProps";
import { ColumnElementConstructor } from "../ColumnElementConstructor";
import { Custom } from "./Custom";
import { getFormattedValue } from "../helpers";
import { Color } from "../../../general";
import { Shelf, Stack } from "../../../layout";
import { TextColor } from "../../../typography";
import styles from "./styles.module.scss";

/**
 * The `Accounting` component properties.
 */
export interface AccountingProps extends Omit<BaseColumnProps, "align"> {
  /**
  * The minimum number of fraction digits to use The maximum number of fraction digits to use and possible values are from 0 to 100.
  */
   readonly minimumFractionDigits?: number;

   /**
    * The maximum number of fraction digits to use The maximum number of fraction digits to use and possible values are from 0 to 100.
    */
   readonly maximumFractionDigits?: number;
 }

/**
 * Column which displays formatted Accounting values.
 */
export const Accounting: FC<AccountingProps> = (props) => {
  const { minimumFractionDigits, maximumFractionDigits } = props;

  const displayCurrency = (value: string | number) => {
    if (Math.sign(Number(value)) === -1) {
      return (<TextColor appearance={Color.Red[600]}> {`(${getFormattedValue(value, minimumFractionDigits, maximumFractionDigits)})`}</TextColor>);
    } else {
      return getFormattedValue(value, minimumFractionDigits, maximumFractionDigits);
    }
  };

  return (
    <Custom {...props} >
      {(value) => {
        if (value === null) return "--";
        if (typeof value === "undefined") return "--";
        return (<Shelf>
          <Stack spacing="none" alignment="left">{Math.sign(Number(value)) === -1 ? <TextColor appearance={Color.Red[600]}>$</TextColor> : "$"}</Stack>
          <Shelf.Spacer />
          <Shelf spacing="none">
            {(typeof value === "string") && (displayCurrency(value) || "--")}
            {(typeof value === "number") && displayCurrency(value.toString())}
          </Shelf>
        </Shelf>);
      }}
    </Custom>
  );
};

(Accounting as ColumnElementConstructor<AccountingProps>).headerAlignment = "right";
(Accounting as ColumnElementConstructor<AccountingProps>).className = classNames(styles.Numerical, "accounting");
